<template>
  <div class="sign-in">
    <div class="side">
      <div class="welcome">
        <div class="img-container">
          <!-- <img src="@/assets/images/img-turntable/img-turntable.svg" alt="disc" title="disc"> -->
          <img class="img" src="@/assets/images/auth/img-turntable.svg" alt="disc" title="disc">
        </div>
        <div class="text-container">
          <div class="text" v-html="$t('AUTH.SLOGAN') " />
        </div>
      </div>
    </div>
    <div class="panel">
      <div class="panel-container">
        <div class="logo">
          <Logo :text-in-mobile="true" />
        </div>
        <a class="cancel" @click="cancel">
          <i class="icon material-icons">
            close
          </i>
        </a>
        <Transition name="fade" mode="out-in">
          <h1
            v-if="type === 'SIGN_IN' && !signInFormMode"
            key="WELCOME"
            class="title"
          >
            {{ $t('AUTH.WELCOME') }}
          </h1>
          <h1
            v-if="type === 'SIGN_IN' && signInFormMode"
            key="SIGNIN"
            class="title"
          >
            {{ $t('AUTH.SIGN_IN') }}
          </h1>
          <h1 v-if="type === 'SIGN_UP'" key="SIGNUP" class="title">
            {{ $t('AUTH.SIGN_UP') }}
          </h1>
        </Transition>
        <div class="content">
          <Transition name="fade" mode="out-in">
            <div v-if="type === 'SIGN_IN' && !signInFormMode && isSDKLoaded" key="sigInList">
              <h2 class="subtitle">
                <!--  -->
              </h2>
              <div v-if="!isCN" class="auth-list">
                <a v-show="allowSignInWithFB" class="auth-item facebook" @click="loginWithFacebook">
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-fb.svg"
                    alt="facebook-signin"
                  >
                  <span
                    class="auth-item-text"
                  >
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'Facebook'}) }}
                  </span>
                </a>
                <a class="auth-item twitter" @click="loginWithTwitter">
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-twitter.svg"
                    alt="twitter-signin"
                  >
                  <span
                    class="auth-item-text"
                  >
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'Twitter'}) }}
                  </span>
                </a>
                <a id="signInWithLineBtn" class="auth-item line" @click="loginWithLine">
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-line.svg"
                    alt="line-signin"
                  >
                  <span
                    class="auth-item-text"
                  >
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'Line'}) }}
                  </span>
                </a>
                <a
                  v-show="allowSignInWithGoogle"
                  id="signInWithGoogleBtn"
                  class="auth-item google"
                  @click="loginWithGoogle"
                >
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-google.svg"
                    alt="google-signin"
                  >
                  <span class="auth-item-text">
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'Google'}) }}
                  </span>
                </a>
                <a class="auth-item email" @click="updateFormMode">
                  <i class="auth-item-logo material-icons">
                    mail
                  </i>
                  <span class="auth-item-text">
                    {{ $t('AUTH.SIGN_IN_WITH', { 'application': 'Email'}) }}
                  </span>
                </a>
              </div>
              <div v-else class="auth-list">
                <!-- <a id="signInWithWeixinBtn" class="auth-item weixin" @click="loginWithWeixin">
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-weixin.svg"
                    alt="weixin-signin"
                  >
                  <span
                    class="auth-item-text"
                  >
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'Weixin'}) }}
                  </span>
                </a> -->
                <a id="signInWithQQBtn" class="auth-item qq" @click="loginWithQQ">
                  <img
                    class="auth-item-logo"
                    src="@/assets/images/auth/img-logo-qq.svg"
                    alt="qq-signin"
                  >
                  <span
                    class="auth-item-text"
                  >
                    {{ $t('AUTH.CONTINUE_WITH', { 'application': 'QQ'}) }}
                  </span>
                </a>
                <a class="auth-item email" @click="updateFormMode">
                  <i class="auth-item-logo material-icons">
                    mail
                  </i>
                  <span class="auth-item-text">
                    {{ $t('AUTH.SIGN_IN_WITH', { 'application': 'Email'}) }}
                  </span>
                </a>
              </div>
              <div class="auth-help-text">
                {{ $t('AUTH.NO_ACCOUNT') }}
                <a
                  class="auth-help-link"
                  @click="updateAuthType"
                >
                  {{ $t('AUTH.CREATE_ONE') }}
                </a>
              </div>
            </div>
            <div v-else-if="type === 'SIGN_IN' && signInFormMode" key="sigInForm">
              <h2 v-if="!isCN" class="subtitle">
                {{ $t('AUTH.PREFIX_SIGN_IN_WITH') }}
                <a class="link" @click="updateFormMode">
                  <span>Facebook</span>
                </a>
                {{ $t('COMMON.COMMA') }}
                <a class="link" @click="updateFormMode">
                  <span>Twitter</span>
                </a>
                {{ $t('COMMON.COMMA') }}
                <a class="link" @click="updateFormMode">
                  <span>Google</span>
                </a>
                {{ $t('COMMON.OR') }}
                <a class="link" @click="updateFormMode">
                  <span>Line</span>
                </a>
                {{ $t('AUTH.POSTFIX_SIGN_IN_WITH') }}
              </h2>
              <h2 v-else class="subtitle">
                <!--  -->
              </h2>
              <SignInForm />
              <a
                class="forget-password"
                @click="openResetPasswordModal = true"
              >
                {{ $t('AUTH.FORGET_PASSWORD') }}
              </a>
            </div>
            <div v-else-if="type === 'SIGN_UP'" key="signUpForm">
              <h2 v-if="!isCN" class="subtitle">
                {{ $t('AUTH.PREFIX_SIGN_IN_WITH') }}
                <a class="link" @click="resetFormMode(false)">
                  <span>Facebook</span>
                </a>
                {{ $t('COMMON.COMMA') }}
                <a class="link" @click="resetFormMode(false)">
                  <span>Twitter</span>
                </a>
                {{ $t('COMMON.COMMA') }}
                <a class="link" @click="resetFormMode(false)">
                  <span>Google</span>
                </a>
                {{ $t('COMMON.OR') }}
                <a class="link" @click="resetFormMode(false)">
                  <span>Line</span>
                </a>
                {{ $t('AUTH.POSTFIX_SIGN_IN_WITH') }}
              </h2>
              <h2 v-else class="subtitle">
                <!--  -->
              </h2>
              <SignUpForm @reset="resetFormMode" />
            </div>
          </Transition>
        </div>
        <div class="panel-announcement-push" />
      </div>
      <!-- announcement -->
      <div class="panel-announcement">
        {{ $t('AUTH.PREFIX_AGREE_TO') }}
        <RouterLink
          :to="{name: 'terms', params: {locale: this.$i18n.localePath()}}"
          class="link"
        >
          {{ $t('TERMS.TITLE') }}
        </RouterLink>
        {{ $t('COMMON.AND') }}
        <RouterLink
          :to="{name: 'privacy', params: {locale: this.$i18n.localePath()}}"
          class="link"
        >
          {{ $t('PRIVACY.TITLE') }}
        </RouterLink>
      </div>
    </div>
    <div v-if="loading" class="signin-mask">
      <Loader />
    </div>
    <ResetPasswordModal :open="openResetPasswordModal" @close="openResetPasswordModal = false" />
  </div>
</template>
<script>
// import Axios from 'axios'
import Logo from '@/components/common/Logo'
import Loader from '@/components/common/Loader'
import SignInForm from '@/components/auth/SignInForm'
import SignUpForm from '@/components/auth/SignUpForm'
import ResetPasswordModal from '@/components/auth/ResetPasswordModal'
import AuthService from '@/assets/services/AuthService'

const GOOGLE_CLIENT_ID = process.env.VUE_APP_GOOGLE_CLIENT_ID
const LINE_CLIENT_ID = process.env.VUE_APP_LINE_CLIENT_ID
const QQ_CLIENT_ID = process.env.VUE_APP_QQ_CLIENT_ID

export default {
  name: 'Signin',
  components: {
    Logo,
    Loader,
    SignInForm,
    SignUpForm,
    ResetPasswordModal
  },
  directives: {},
  props: {},
  data() {
    return {
      isSDKLoaded: false,
      isCN: this.$isCN,
      loading: false,
      type: 'SIGN_IN', // SIGN_IN, SIGN_UP
      signInFormMode: false,
      openResetPasswordModal: false,
      allowSignInWithGoogle: true,
      allowSignInWithFB: true
    }
  },
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { vmid: 'name', name: 'name', content: this.title },
        { vmid: 'description', name: 'description', content: this.description },
        { vmid: 'image', name: 'image', content: this.cover },
        { vmid: 'keywords', name: 'keywords', content: this.keywords },
        { vmid: 'og:title', name: 'og:title', content: this.title },
        { vmid: 'og:description', name: 'og:description', content: this.description },
        { vmid: 'og:image', name: 'og:image', content: this.cover },
        { vmid: 'og:url', name: 'og:url', content: this.canonicalURL },
        { vmid: 'google-signin-scope', name: 'google-signin-scope', content: 'profile email openid' }
        // { vmid: 'google-signin-client_id', name: 'google-signin-client_id', content: GOOGLE_CLIENT_ID }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.canonicalURL },
        { vmid: 'image_src', rel: 'image_src', href: this.cover }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [{ innerHTML: JSON.stringify(this.structuredData), type: 'application/ld+json' }]
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    title() {
      const productionLocaleName = this.$t(`${this.$production.toUpperCase()}.TITLE`)
      const authTypeLocaleText = this.$t(`AUTH.${this.type}`)
      return `${authTypeLocaleText} | ${productionLocaleName} | MUZIK AIR`
    },
    description() {
      return this.$t('AUTH.SIGN_IN')
    },
    keywords() {
      return this.$t('AUTH.SIGN_IN')
    },
    cover() {
      const subDomainKey = `VUE_APPMUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const coverPath = this.$production.toLowerCase()
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/img/cover-social/${coverPath}.png`
    },
    canonicalURL() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      return isAirProduction
        ? `https://${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/signin`
        : `https://${process.env[subDomainKey]}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/signin`
    },
    structuredData() {
      const subDomainKey = `VUE_APP_MUZIK_${this.$production.toUpperCase()}`
      const isAirProduction = (this.$production === 'AIR') &&
                              (process.env['VUE_APP_MUZIK_STAGE'] === 'production')
      const urlSubDomain = isAirProduction ? '' : `${process.env[subDomainKey]}.`
      const structuredData = {
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        '@id': this.canonicalURL,
        url: this.canonicalURL,
        image: this.cover,
        name: this.title,
        description: this.description,
        relatedLink: [
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/terms`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/privacy`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/about`,
          `https://${urlSubDomain}${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/mediaKit`
        ]
      }
      return structuredData
    },
    redirectURL() {
      return this.$route.query.redirectURL || `/${this.$i18n.localePath()}`
    }
  },
  watch: {},
  async created() {
    this.isSDKLoaded = false
    if (this.$route.query.type) {
      this.type = this.$route.query.type === 'SIGN_UP' ? 'SIGN_UP' : 'SIGN_IN'
    }

    // TW
    if (this.$route.query.oauth_token && this.$route.query.oauth_verifier) {
      window.close()
    }

    // LINE
    if (this.$route.query.code && this.$route.query.state) {
      window.close()
    }

    // QQ
    if (this.$route.query.access_token && this.$route.query.expires_in) {
      window.close()
    }

    if (this.isAuthenticated) {
      setTimeout(() => {
        this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_IN_SUCCESS', type: 'success' })
      }, 500)
      this.$router.back(-1)
    }

    if (!this.isCN) {
      const promiseList = [this.loadGoggleSDK(), this.loadFacebookSDK()]
      await Promise.all(promiseList)
      // ///////////////////
      this.initFacebookSDK()
      this.initGoogleSDK()
      this.initTwitterSDK()
      this.isSDKLoaded = true
    } else {
      const promiseList = [this.loadQQSDK()]
      await Promise.all(promiseList)
      this.initQQSDK()
      this.isSDKLoaded = true
    }
  },
  mounted() {
  },
  updated() {},
  methods: {
    cancel() {
      if (this.redirectURL) {
        if (this.redirectURL.match(/watch/g)) {
          window.location.href = this.redirectURL
        } else {
          this.$router.push(this.redirectURL)
        }
      } else {
        // this.$router.go(-1)
        this.$router.push({ name: 'index', params: { locale: this.$i18n.localePath() } })
      }
    },
    updateAuthType() {
      this.type = this.type === 'SIGN_IN' ? 'SIGN_UP' : 'SIGN_IN'
      this.$router.replace({
        query: {
          type: this.type,
          redirectURL: this.redirectURL
        }
      })
    },
    updateFormMode() {
      this.signInFormMode = !this.signInFormMode
    },
    resetFormMode(signInFormMode) {
      this.signInFormMode = signInFormMode || false
      if (this.type === 'SIGN_UP') {
        this.updateAuthType()
      }
    },
    async loadGoggleSDK() {
      const vm = this
      return new Promise((resolve, reject) => {
        let srcJS = document.createElement('script')
        srcJS.async = true
        srcJS.defer = true
        srcJS.type = 'text/javascript'
        srcJS.src = 'https://apis.google.com/js/platform.js'
        document.head.appendChild(srcJS)
        srcJS.onload = () => {
          resolve()
        }
        srcJS.onerror = err => {
          // console.error('loadGoggleSDK onerror')
          vm.allowSignInWithGoogle = false
          resolve(err) // pass this step
        }
      })
    },
    async loadFacebookSDK() {
      const vm = this
      const localeStr = this.$i18n.locale.replace('-', '_') // need semi before IIFE
      return new Promise((resolve, reject) => {
        let srcJS = document.createElement('script')
        srcJS.async = true
        srcJS.defer = true
        srcJS.type = 'text/javascript'
        srcJS.src = `https://connect.facebook.net/${localeStr}/sdk.js`
        document.head.appendChild(srcJS)
        srcJS.onload = () => {
          resolve()
        }
        srcJS.onerror = err => {
          // console.eror('loadFacebookSDK onerror')
          vm.allowSignInWithFB = false
          resolve(err) // pass this step
        }
      })
    },
    async loadQQSDK() {
      const vm = this
      return new Promise((resolve, reject) => {
        let srcJS = document.createElement('script')
        srcJS.async = true
        srcJS.defer = true
        srcJS.type = 'text/javascript'
        srcJS.src = 'http://connect.qq.com/qc_jssdk.js'
        srcJS['data-appid'] = QQ_CLIENT_ID
        srcJS['data-redirecturi'] = window.location.href
        document.head.appendChild(srcJS)
        srcJS.onload = () => {
          resolve()
        }
        srcJS.onerror = err => {
          // console.error('loadGoggleSDK onerror')
          vm.allowSignInWithQQ = false
          resolve(err) // pass this step
        }
      })
    },
    async initFacebookSDK() {
      // init after loaded, or just use window.fbAsyncInit. like:
      // https://developers.facebook.com/docs/javascript/quickstart
      /* eslint-disable */
      if (window.FB && window.FB.init && window.FB.login) {
        try {
          FB.init({
            appId: process.env.VUE_APP_FB_APP_ID,
            autoLogAppEvents: true,
            xfbml: true,
            version: process.env.VUE_APP_FB_SDK_VER
          })
        } catch (error) {
          // console.log('Disable signin with Facebook.')
          this.allowSignInWithFB = false
        }
      } else {
        this.allowSignInWithFB = false
      }
      /* eslint-enable */
    },
    async initGoogleSDK() {
      /* eslint-disable */
      try {
        gapi.load('auth2', () => {
          const auth2 = gapi.auth2.init({
            client_id: GOOGLE_CLIENT_ID,
            cookiepolicy: 'single_host_origin'
            // Request scopes in addition to 'profile' and 'email'
            //scope: 'additional_scope'
          })
          // Listen for sign-in state changes.
          auth2.isSignedIn.listen(this.googleSigninChanged)
          // Listen for changes to current user.
          // auth2.currentUser.listen(this.googleUserChanged)
        })
      } catch (error) {
        // console.log('Disable signin with Google.')
        this.allowSignInWithGoogle = false
      }
      /* eslint-enable */
    },
    async initTwitterSDK() {
      /* eslint-disable */
      /* eslint-enable */
    },
    async initQQSDK() {
      /* eslint-disable */
      if (window.QC) {
        if (QC.Login.check()) {
          QC.Login.getMe(function(openId, accessToken) {
            localStorage.setItem('access_token', accessToken)
            localStorage.setItem('openid', openId)
            window.close()
          })
        }
      }
      // QC.api("get_user_info", {})
      //   // 指定介面訪問成功的接收函式，s為成功返回Response物件
      //   .success(function(s) {
      //     console.log(s)
      //     // alert('獲取使用者資訊成功！當前使用者暱稱為：' s.data.nickname)
      //   })
      //   .error(function(f) {
      //     alert("獲取使用者資訊失敗！")
      //   })
      //   .complete(function(c) {
      //     alert("獲取使用者資訊完成！")
      //   })
      /* eslint-enable */
    },
    googleSigninChanged(val) {
      // console.log('Google Signin state changed to ', val)
    },
    googleUserChanged(googleUser) {
      /* eslint-disable */
      if (googleUser) {
        const params = {
          provider: 'google',
          provider_id: googleUser.getId(),
          token: googleUser.getAuthResponse().access_token,
          user_id: ''
        }
        this.providingUser(params)
      } else {
      }
      /* eslint-enable */
    },
    async providingUser(params) {
      this.loading = true
      const methodValue = params.provider
      const res = await AuthService.provider(params)
      if (res && res.data && (res.status === 201 || res.data.token)) {
        this.$store.dispatch('GTAG_EVENT', {
          action: 'login',
          data: { method: methodValue }
        })
        if (this.redirectURL.match(/watch/g)) {
          window.location.href = this.redirectURL
        } else {
          this.$router.push(this.redirectURL)
          setTimeout(() => {
            this.loading = false
            this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_IN_SUCCESS', type: 'success' })
          }, 500)
        }
      } else {
        this.loading = false
        this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_IN_ERROR', type: 'error' })
      }
    },
    loginWithFacebook() {
      /* eslint-disable */
      FB.login(response => {
        if (response.status === 'connected') {
          FB.api('/me', function(response) {
            // console.log('Good to see you, ' + response.name + '.', response)
          })
          const params = {
            provider: 'facebook',
            provider_id: response.authResponse.userID,
            token: response.authResponse.accessToken,
            user_id: ''
          }
          this.providingUser(params)
        } else {
          this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.SIGN_IN_ERROR', type: 'error' })
        }
      }, {
        scope: 'email, public_profile',
        auth_type: 'rerequest',
        return_scopes: true,
      })
      /* eslint-enable */
    },
    loginWithGoogle(googleUser) {
      /* eslint-disable */
      const auth2 = gapi.auth2.getAuthInstance()
      auth2.currentUser.listen(this.googleUserChanged)
      auth2.signIn()
        .then(
          () => {
          },
          (error) => {
          if (error && error.error === 'popup_blocked_by_browser') {
            this.$store.commit('ALERT_MESSAGE', { message: 'AUTH.ALLOW_POPUPS_WINDOW', type: 'error' })
          }
        })
      /* eslint-enable */
    },
    async loginWithTwitter() {
      /* eslint-disable */
      this.loading = true
      const params = {
        redirect_url: window.location.href
      }
      const res = await AuthService.twitterequestToken(params)
      const { oauth_token, oauth_token_secret } = res.data
      if (oauth_token) {
        const url = `https://api.twitter.com/oauth/authenticate?oauth_token=${oauth_token}`
        // window.location.href = url
        const popup = window.open(url, '_blank', 'height=400,width=800,left=250,top=100,resizable=yes', true)
        const timer = setInterval(checkChildWindow, 100)
        let accessTokenParams = {
          oauth_token,
          oauth_token_secret,
          oauth_verifier: '',
          redirect_url: ''
        }
        const vm = this
        async function checkChildWindow() {
          if (!popup) {
            clearInterval(timer)
            vm.loading = false
            vm.$store.commit('ALERT_MESSAGE', { message: 'AUTH.ALLOW_POPUPS_WINDOW', type: 'error' })
          } else if (popup.closed) {
            clearInterval(timer)
            if (accessTokenParams.oauth_verifier) {
              const res = await AuthService.twitterAccessToken(accessTokenParams)
              if (res && res.data && res.status === 200) {
                const params = {
                  provider: 'twitter',
                  provider_id: res.data.user_id,
                  token: res.data.oauth_token,
                  token_secret: res.data.oauth_token_secret,
                  user_id: ''
                }
                vm.providingUser(params)
              } else {
                // console.error('GET Twitter access token error')
                vm.loading = false
              }
            } else {
              // console.error('No twitter oauth verifier')
              vm.loading = false
            }
          } else {
            if (popup && popup.location) {
              // get callback auth params
              const token = popup.location.search.match(/oauth_token=([^&]*)/)
              const verifier = popup.location.search.match(/oauth_verifier=([^&]*)/)
              if (token && token[1]) accessTokenParams.oauth_token = token[1]
              if (verifier && verifier[1]) accessTokenParams.oauth_verifier = verifier[1]
            }
            // contiune checking...
          }
        }
      } else {
        this.loading = false
      }
      /* eslint-enable */
    },
    async loginWithLine() {
      /* eslint-disable */

      this.loading = true
      const redirectURL = window.location.href.split('?')[0]
      const state = 'LINE_STATE'

      const url = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${LINE_CLIENT_ID}&redirect_uri=${redirectURL}&state=${state}&scope=openid+profile+email`
      // window.location.href = url
      const popup = window.open(url, '_blank', `height=565,width=400,resizable=yes`, true)
      const timer = setInterval(checkChildWindow, 100)
      const vm = this
      let code = ''
      async function checkChildWindow() {
          if (!popup) {
            clearInterval(timer)
            vm.loading = false
            vm.$store.commit('ALERT_MESSAGE', { message: 'AUTH.ALLOW_POPUPS_WINDOW', type: 'error' })
          } else if (popup.closed) {
          // console.log(`closed popup, and LINE response code = ${code}`)
          clearInterval(timer)
          if (code) {
            const params = {
              provider: 'line',
              provider_id: code, // assign a value for pass validation
              token: code,
              user_id: '',
              // redirect_url: redirectURL,
              request_url: redirectURL
            }
            vm.providingUser(params)
          } else {
            // console.error('No LINE response code.')
            vm.loading = false
          }
        } else {
          if (popup && popup.location) {
            // get callback auth params
            const codeFromQuery = popup.location.search.match(/code=([^&]*)/)
            if (codeFromQuery && codeFromQuery[1]) code = codeFromQuery[1]
          }
          // contiune checking...
        }
      }
      /* eslint-enable */
    },
    async loginWithWeixin() {
    },
    async loginWithQQ() {
      this.loading = true
      var url = 'https://graph.qq.com/oauth2.0/authorize?client_id=' + QQ_CLIENT_ID + '&response_type=token&redirect_uri=' + window.location.href
      const popup = window.open(url, '_blank', 'height=525, width=585, left=250, top=100, resizable=yes', true)
      const timer = setInterval(checkChildWindow, 100)
      const vm = this
      let accessToken = ''
      let openId = ''
      let windowClosed = false
      // let expiresIn = ''
      async function checkChildWindow() {
        if (!popup) {
          clearInterval(timer)
          vm.loading = false
          vm.$store.commit('ALERT_MESSAGE', { message: 'AUTH.ALLOW_POPUPS_WINDOW', type: 'error' })
        } else if (windowClosed) {
          clearInterval(timer)
          if (accessToken) {
            const params = {
              provider: 'qq',
              provider_id: openId, // assign a value for pass validation
              token: accessToken,
              user_id: '',
              request_url: ''
            }
            vm.providingUser(params)
            popup.close()
          } else {
            vm.loading = false
          }
        } else {
          if (popup && popup.location) {
            // get callback auth params
            const id = localStorage && localStorage.openid
            const token = popup.location.hash.match(/access_token=([^&]*)/)
            // const expires = popup.location.hash.match(/expires_in=([^&]*)/)
            if (token && token[1]) {
              accessToken = token[1]
              windowClosed = true
            }
            // if (expires && expires[1]) expiresIn = expires[1]
            if (id) openId = id
          }
        }
      }
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/scss/variables.scss';
// @import '@/assets/scss/component/button.scss';
@import '@/assets/scss/auth/auth.scss';
</style>
